























import Vue from 'vue';
import FaIcon from '@/components/FaIcon.vue';

export default Vue.extend({
  components: {
    FaIcon,
  },
  methods: {
    onClickPageBreak() {
      this.$emit('click-page-break');
    },
    onClickPrint() {
      this.$emit('click-print');
    },
  },
});
